import { isNil } from '@flowio/is';
import { DomReference } from '../types';
import { resolveElement } from '../utilities/elementHelpers';
import handlePostRedirect from './handlePostRedirect';

export default function handleRedirectAction(
  mountContainer: DomReference | undefined,
  action: io.flow.v0.models.ActionRedirect,
): void {
  switch (String(action.method).toLowerCase()) {
    case 'get':
      window.location.assign(action.url);
      break;
    case 'post': {
      let container: HTMLElement | undefined;
      try {
        if (mountContainer) {
          container = resolveElement(mountContainer);
        }
      } catch (e) {
        // deliberately empty
      }
      // if there happens to be no mount element, we can just use <body> for redirect purposes.
      if (isNil(container)) {
        container = document.body;
      }

      handlePostRedirect(
        action.url,
        container,
        action.data,
      );
      break;
    }
    default:
      throw new Error(`Unsupported redirect method: ${action.method}`);
  }
}
